<div *ngIf="formGroup" (clickOutside)="close()">
    <ng-template #exportToggleRef>
        <lsq-icon
            [type]="icons.Export"
            [color]="colors.Green"
            [style.padding-left.rem]="0.5"
        ></lsq-icon>
    </ng-template>

    <lsq-toggle-dropdown
        #dropdownRef
        direction="left"
        [toggleTemplateRef]="exportToggleRef"
        (open)="onOpen()"
        (close)="display = false"
    >
        <div id="export-form-main">
            <form class="export-form" [formGroup]="formGroup" (ngSubmit)="handleSubmit($event)">
                <h2 id="export-form-title" i18n="Export form header">Export</h2>
                <span id="export-form-date-range">{{ subTitle }}</span>
                <div [style.margin]="'2rem 0'">
                    <lsq-radio-list
                        label="Export:"
                        [labelClassName]="'text-white'"
                        [formGroup]="formGroup"
                        formControlName="select"
                        name="exportFormat"
                        [vertical]="false"
                        [options]="options"
                    >
                    </lsq-radio-list>
                </div>
                <div
                    *ngIf="!!optionalExportApiServiceConfig"
                    class="text-white"
                    [style.margin-bottom.rem]="2"
                >
                    <lsq-checkbox
                        [id]="'additional-service-checkbox'"
                        [(ngModel)]="useOptionalService"
                        [ngModelOptions]="{ standalone: true }"
                        [label]="optionalExportApiServiceConfig.label"
                    >
                    </lsq-checkbox>
                </div>
                <div class="text-right">
                    <lsq-button
                        id="export-button"
                        type="submit"
                        size="sm"
                        [submitting]="isLoadingReport"
                        [disabled]="isExportOptionSelected()"
                        i18n="Download button for export reports form"
                    >
                        Download
                    </lsq-button>
                </div>
            </form>

            <!-- TODO(dheins) add share report feature (Milestone 7) -->
            <ng-container *featureFlag="shareServiceFeatureFlag">
                <span *ngIf="!!shareService" class="line"></span>
                <form
                    *ngIf="!!shareService"
                    [formGroup]="formGroupEmail"
                    (ngSubmit)="handleSubmit($event)"
                >
                    <h3 id="share">Or share with others</h3>
                    <div id="container">
                        <lsq-input
                            *ngIf="recipients.length < 10"
                            name="email"
                            placeholder="Enter Email Addresses..."
                            formControlName="email"
                            [floatLabel]="false"
                            [group]="formGroupEmail"
                            [prependIcon]="[icons.Person, colors.Black]"
                        >
                        </lsq-input>
                        <ul>
                            <li *ngFor="let recipient of recipients; index as i">
                                <div id="recipient">
                                    <span>{{ recipient }}</span>
                                    <lsq-icon
                                        class="center_vertically"
                                        [type]="icons.CloseSmall"
                                        (mousedown)="handleRemoveRecipient(i, $event)"
                                    ></lsq-icon>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <!-- TODO(dheins): Change input to an lsq-button and make it visible -->
                    <input
                        type="submit"
                        style="display: none;"
                        id="btnHidden"
                        (click)="handleAddRecipient($event)"
                    />
                    <a
                        *ngIf="recipients.length > 0 && !isExportOptionSelected()"
                        (click)="handleSend($event)"
                        id="sendBtn"
                        >SEND</a
                    >
                </form>
            </ng-container>
        </div>
    </lsq-toggle-dropdown>
</div>
